class Extends {

    constructor() {

        // handling error messages
        $("textarea").focus(function(ev){
            removeError(ev);
        });
          
        $("input").focus(function(ev){
            removeError(ev);
        });


        function removeError(ev) {
            let elem = document.getElementById(`eroare-${ev.target.id}`);
            let successMessage = document.getElementById('js-success-message');
            
            if (successMessage) {
                $('#js-success-message').css('display', 'none');
            }

            if (elem) {
                elem.parentNode.removeChild(elem);
            }
        }

        // recaptcha
        function cleanupForm() {
            $('#dorinta').val('');
            $('#regulament').prop("checked", false);
          }

          
        function getRecaptchaToken() {
            return new Promise(resolve => {
              grecaptcha.ready(function() {
                grecaptcha.execute(window.recaptcha_site_key, {action: 'submit'}).then(resolve);
              });
            });
          }
          
          $('#js-form-submit-button').on('click', function (ev) {
              ev.preventDefault();
          
              const $form = $('#wish');
          
              const requestData = {
                  dorinta: $('#dorinta').val(),
                  regulament: $('#regulament:checked').val(),
              };
              
              getRecaptchaToken().then(token => {
                  requestData.recaptcha_token = token;
          
                  $.ajax('/api/dorinta', {
                    method: 'POST',
                    dataType: 'json',
                    data: requestData,
                    beforeSend: function () {
                        $form.find('.form-error').remove();
                    },
                    success: function (response) {
                      cleanupForm();
                      $('#js-success-message').css('display', 'block');
                    },
                    error: function (response) {
                      if (response.responseJSON.error) {
                        return toastr.error(response.responseJSON.error, getToastrOptions());
                      } else if (response.responseJSON.errors) {
                        const errors = response.responseJSON.errors;
          
                        for (let field in errors) {
                          if (!errors.hasOwnProperty(field)) continue;
          
                          if (!document.getElementById(`eroare-${field}`)) {
                            $(`#js-${field}`).append(createFormErrorElement(errors[field], `eroare-${field}`));
                          }
          
                        }
                      } else {
                        toastr.error('An error was encountered', getToastrOptions());
                      }
                    }
                  })
          
              });
          
          });

          function createFormErrorElement(errorsArray, name) {
            return $(`<span class="form-error" id="${name}" />`).addClass('text-danger')
              .html(errorsArray.join('\n'))
          }

    }

}
window.Extends = Extends;


// WEBPACK FOOTER //
// ./resources/assets/js/extends.js